module.exports = "<div>\n  <div id=\"secureContainerWrapper\">\n      <div id=\"secureContainer\" class=\"secureContainer\" height=\"600px\">\n      </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component.html
// module id = ../../../../../src/app/components/payment/nuvei-checkout/nuvei-checkout-modal/nuvei-checkout-modal.component.html
// module chunks = main